import Layout from "app/components/layout/Layout";
import AuthGuard from "app/guard/authGuard";
import { lazy } from "react";
import { dbRouter } from "./dbRouter";
import { mpRouter } from "./mpRouter";
import { rpRouter } from "./rpRouter";
import { cbRouter } from "./cbRouter";
import { otRouter } from "./otRouter";
import { reportRouter } from "./reportRouter";
import { pcRouter } from "./pcRouter";
import { infoRouter } from "./infoRouter";
import { adminRouter } from "./adminRouter";

const NotFound = lazy(() => import("app/pages/error/NotFound"));


export const indexRouter: any = {
  path: "/",
  element: (
      <AuthGuard>
        <Layout/>
      </AuthGuard>
  ),
  children: [
    // user or common routers
    ...dbRouter,
    ...mpRouter,
    ...rpRouter,
    ...cbRouter,
    ...otRouter,
    ...reportRouter,
    ...pcRouter,
    ...infoRouter,

    // admin router
    ...adminRouter,

    // 없는 주소 (반드시 마지막)
    { path: '*', element: <NotFound /> },
  ],
};